<template>
    <div id="event-selection">
        <div class="modal fade in" style="display: block;">
            <div class="modal-dialog" role="document" v-if="teamNameFromUrl && error">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            <img :src="logo">
                        </h4>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-danger mb-0" role="alert">
                            <strong>{{ $t('common.error') }}</strong> {{ $t('errors.' + error) }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-dialog" role="document" v-if="!teamNameFromUrl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            <img :src="logo">
                        </h4>
                    </div>
                    <form @submit.prevent="eventId && selectEvent(eventId)">
                        <div class="modal-body">
                            <div class="form-group">
                                <label>{{ $t('event_selection.new_game') }}</label>
                                <div class="input-group">
                                    <input class="form-control" type="text" :placeholder="$t('event_selection.game_code')"
                                           v-model="eventId">
                                    <span class="input-group-btn">
                                        <button type="submit" class="btn btn-primary" :disabled="loading">
                                            <i class="fa"
                                               :class="{'fa-refresh fa-fast-spin': loading, 'fa-sign-in': !loading}"
                                               aria-hidden="true"></i> {{ $t('event_selection.start') }}
                                        </button>
                                    </span>
                                </div>
                            </div>
                            <div class="alert alert-danger" role="alert" v-if="error">
                                <strong>{{ $t('common.error') }}</strong> {{ $t('errors.' + error) }}
                            </div>
                            <div v-if="recentEvents.length">
                                <hr>
                                <label>{{ $t('event_selection.recent_games') }}</label>
                                <div class="list-group">
                                    <div class="list-group-item" v-for="event in recentEvents" :key="event._id">
                                        <img class="event-logo" :src="event.logo">
                                        {{event.title}}
                                        <a class="float-xs-right" href
                                           v-if="!error || loadingId !== event._id"
                                           @click.prevent="(eventId = event._id) && selectEvent(event._id)">
                                            <small>
                                                <i class="fa fa-repeat"
                                                   :class="{'fa-fast-spin': loading && loadingId === event._id}"
                                                   aria-hidden="true"></i>
                                                {{ $t('common.continue') }}
                                            </small>
                                        </a>
                                        <a class="float-xs-right text-danger" href
                                           v-if="error && loadingId === event._id"
                                           @click.prevent="(eventId = event._id) && selectEvent(event._id)">
                                            <small>
                                                <i class="fa fa-repeat"
                                                   :class="{'fa-fast-spin': loading && loadingId === event._id}"
                                                   aria-hidden="true"></i>
                                                {{ $t('common.retry') }}
                                            </small>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="modal-backdrop fade in"></div>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data () {
            return {
                logo: LOGO,
                eventId: '',
                teamNameFromUrl: !!TEAM_NAME_FROM_URL
            };
        },
        computed: mapState({
            recentEvents: state => state.events.recentEvents,
            loading: state => state.events.loading,
            loadingId: state => state.events.loadingId,
            error: state => state.events.error,
            activateEventByPathname: state => state.events.activateEventByPathname
        }),
        methods: mapActions([
            'selectEvent'
        ]),
        mounted() {
            if (this.activateEventByPathname && window.location.pathname.length > 1) {
                this.eventId = window.location.pathname.split('/')[1]
                this.selectEvent(this.eventId)
            }
        }
    }
</script>

<style>
    #event-selection .event-logo {
        max-height: 20px;
        max-width: 50px;
    }

    .fa-fast-spin {
        -webkit-animation: fa-spin 1s infinite linear;
        animation: fa-spin 1s infinite linear;
    }
</style>



// WEBPACK FOOTER //
// event_selection.vue?4e806d40